import React, { useEffect } from "react";
import "./thankyouV1.scss";
import { registerWarning, thankSpices } from "../../source";
import { Link } from "react-router-dom";
import { homeURL } from "../../helpers/paths";
import SocialMediaBox from "../../components/SocialMediaBox/SocialMediaBox";
import Cookin from "../../components/Cookin/Cookin";
import ReachOut from "../../components/ReachOut/ReachOut";
import { useLocation, useNavigate } from "react-router-dom";

const ThankyouV1 = () => {
  const location = useLocation();
  const { message } = location.state || {};

  const currentDate = new Date();
  const nextMonthDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    10,
  );
  const nextMonthName = nextMonthDate.toLocaleString("default", {
    month: "long",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="thank_you_sec1">
        <div className="my_container">
          <div className="thank_content_wrap">
            <img src={thankSpices} alt="thank you" className="thank_img" />
            <h2 className="title">
              Thank You for Joining{" "}
              <span className="red">EVEREST TASTE MASTERS</span>
            </h2>
            <p className="desc">
              Welcome to the Everest family! <br /> Your journey towards
              delicious creations & exciting rewards begins now!
            </p>
            <p className="desc date_desc">
              {/* Since you registered after 5 PM on 10th May, your
              registration will be considered for the June cycle, which runs
              from 10th May (after 5 PM) to 10th June (before 5 PM). */}
              {message}
            </p>
            {/* <p className="desc date_desc">
              We have received your registration for the June cycle, which runs
              from 10th {nextMonthName} (after 5 PM) to 10th June (before 5 PM).
            </p> */}
            <div className="cta_wrapper">
              <Link to={homeURL} className="common_cta">
                GO BACK TO HOMEPAGE
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="thank_you_sec2">
        <SocialMediaBox
          title="Follow us on Social Media"
          desc="Stay connected and get inspired by fellow creators cooking up a
              storm with Everest Taste Masters."
          instaLink="https://www.instagram.com/everest_tastemasters/"
          // fbLink="https://www.facebook.com/@everestspices"
          // ytLink="https://www.youtube.com/@everestspices2874"
        />
      </section>

      <section className="thank_you_sec3">
        <ReachOut
          title="Reach Out Anytime"
          description="Got an elaichi in your biryani? We're here to help! Drop us a message at <a href='mailto:media@everestspices.com'>media@everestspices.com<a>"
        />
        <Cookin
          title="Happy cookin’ with Everest Taste Masters!"
          description="Let’s celebrate your creativity & love for food with rewards to
              match your passion"
        />
      </section>
    </>
  );
};

export default ThankyouV1;
